<template>
    <div class="mess-box" :class="{'source18-pad': source == '18'}">
        <div class="view">
            <div class="content">
                <img src="../../assets/iconfont.png" alt="">
                <p>{{text}}</p>
            </div>

            <div class="line"></div>

            <div class="confirm" @click="closeFun()">{{confirm}}</div>
        </div>
    </div>
</template>

<script>
import { getRequest2 } from '../../common/public.js';

export default {
    props: {
        title: {
            type: String,
            default: '提示'
        },
        text: {
            type: String,
            default: '目前只支持最多两款车型对比'
        },
        confirm: {
            type: String,
            default: '确认'
        }
    },
    data () {
        return {
            source: "",
        }
    },
    created () {
        let urlParams = getRequest2();
        this.source = urlParams.source || "";
    },
    methods: {
        closeFun(){
            this.$emit('_isMessageBox');
        },
    },
}
</script>

<style lang="less" src="../../styles/pc.less"></style>
<style lang="less">
.mess-box{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 980;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    .view{
        width: 35%;
        height: 30%;
        background: rgba(51,51,51,.8);
        border-radius: 12px;
        .content{
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 30px;
            padding: 20px 15px;
            width: 100%;
            height: 60%;
            color: #fff;
            img{
                margin-right: 15px;
                width: 26px;
                height: 26px;
            }
        }
        .line{
            margin: 0 auto;
            border-bottom: 1px solid #ffa401;
            width: 80%;
            opacity: .3;
        }
        .confirm{
            margin: 25px auto 0;
            width: 170px;
            height: 45px;
            line-height: 45px;
            border-radius: 12px;
            text-align: center;
            background: #ffa401;
            color: #fff;
            font-size: 24px;
            cursor: pointer;
        }
    }
}

.source18-pad.mess-box {
    .view {
        background-color: #fff;

        .content {
            color: #5F667A;
        }

        .line {
            border-color: #05AFDB;
        }

        .confirm {
            background-color: #05AFDB;
        }
    }
}
</style>
